// extracted by mini-css-extract-plugin
export default {"wrapper":"user-members-list-item-checkbox__wrapper--nPjQ0"};